import React, { useMemo } from 'react';

import { FreeDropDropStatusClasses, FreeDropDropStatusNames } from '../../../../../../../constants';
import { LevelsTableRowCol } from '../levels-table-row-col';
import { useTranslation } from '../../../../../../../hooks';
import { FreeDropTier } from '../../../../../../../models';
import { formatDate } from '../../../../../../../helpers';
import { DropStatus } from '../../../../../../../enums';

interface LevelsTableRowProps {
  dropDate: string;
  status: DropStatus;
  claimLimitPerDrop?: number;
  tiers: Array<FreeDropTier>;
}

export const LevelsTableRow: React.FC<LevelsTableRowProps> = ({
  tiers,
  status,
  dropDate,
  claimLimitPerDrop
}) => {

  const t = useTranslation();

  const sortedTiers = useMemo(() => {
    return tiers.sort((a, b) => a.goal > b.goal ? 1 : -1);
  }, [tiers]);

  return (
    <div className={`free-drop-popup-table-content-row ${FreeDropDropStatusClasses[status]}`}>
      <div className="free-drop-popup-table-content-clm dates">
        <p className="free-drop-popup-table-content-info-dates">
          <span>{formatDate(new Date(dropDate))}</span>
        </p>
        <p className={`ree-drop-popup-table-content-info-status ${FreeDropDropStatusClasses[status]}`}>
          { t(FreeDropDropStatusNames[status]) }
        </p>
      </div>
      {
        sortedTiers.map(({ goal, freeBets }) => (
          <LevelsTableRowCol
            key={goal}
            freeBets={freeBets}
            claimLimitPerDrop={claimLimitPerDrop}
          />
        ))
      }

    </div>
  );
};
